import { takeEvery, put } from 'redux-saga/effects';

import resetPasswordActions from '../actionTypes/resetPasswordActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { RESET_PASSWORD_URL, CHANGE_PASSWORD_URL } from '../routes';

function* resetPassword({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: RESET_PASSWORD_URL,
      method: 'POST',
      data: payload,
    },
    successAction: resetPasswordActions.resetPasswordSuccess,
    failureAction: resetPasswordActions.resetPasswordFailed,
  });
}

function* changePassword({ payload }) {
  const { id, user } = payload;
  yield put({
    type: API_CALL,
    payload: {
      url: CHANGE_PASSWORD_URL.replace(':id', id),
      method: 'POST',
      data: { user },
    },
    successAction: resetPasswordActions.changePasswordSuccess,
    failureAction: resetPasswordActions.changePasswordFailed,
  });
}

export default function* watchresetPassword() {
  yield takeEvery(resetPasswordActions.resetPassword, resetPassword);
  yield takeEvery(resetPasswordActions.changePassword, changePassword);
}
